import type { MessageInstance } from 'antd/es/message/interface';

let messageInstance: MessageInstance | null = null;

export const setMessageInstance = (instance: MessageInstance) => {
  messageInstance = instance;
};

export const appMessage = {
  error: (content: string) => messageInstance?.error(content),
  success: (content: string) => messageInstance?.success(content),
  warning: (content: string) => messageInstance?.warning(content),
};
